// src/components/data/profileStore.js
// Store demo para los datos de perfil y ajustes

const STORAGE_KEY = "lms_demo_perfil";

const DEFAULT_PROFILE = {
  nombre: "Webmaster",
  apellidoPaterno: "Demo",
  apellidoMaterno: "User",
  rol: "Administrador",
  area: "Capacitación",
  puesto: "Administrador de Plataforma",
  email: "webmaster@metalone.mx",
  telefono: "55 1234 5678",
  extension: "101",
  ubicacion: "CDMX",
  avatarUrl: null,
  portadaUrl: null,
  // solo demo (obvio, no es real)
  password: "Demo123*",
};

function canUseStorage() {
  return typeof window !== "undefined" && !!window.localStorage;
}

function loadProfile() {
  if (!canUseStorage()) return DEFAULT_PROFILE;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return DEFAULT_PROFILE;
  try {
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PROFILE, ...parsed };
  } catch {
    return DEFAULT_PROFILE;
  }
}

function saveProfile(perfil) {
  if (!canUseStorage()) return;
  const copy = { ...perfil };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(copy));
}

// --- API Pública ---

export function getProfile() {
  return loadProfile();
}

export function updateProfile(patch) {
  const current = loadProfile();
  const updated = { ...current, ...patch };
  saveProfile(updated);
  return updated;
}

export function updatePassword(currentPassword, newPassword) {
  const profile = loadProfile();
  if (currentPassword !== profile.password) {
    return {
      success: false,
      error: "La contraseña actual no es correcta.",
    };
  }

  if (!newPassword || newPassword.length < 6) {
    return {
      success: false,
      error: "La nueva contraseña debe tener al menos 6 caracteres.",
    };
  }

  const updated = { ...profile, password: newPassword };
  saveProfile(updated);

  return { success: true };
}

export function updateAvatar(avatarDataUrl) {
  const profile = loadProfile();
  const updated = { ...profile, avatarUrl: avatarDataUrl };
  saveProfile(updated);
  return updated;
}

export function updatePortada(portadaDataUrl) {
  const profile = loadProfile();
  const updated = { ...profile, portadaUrl: portadaDataUrl };
  saveProfile(updated);
  return updated;
}
